export const FILTER_ACTIVE_CLASSES =
  'border-informational bg-highlight-background text-informational [&_svg]:text-informational hover:bg-highlight-background/50';

// Shared width for the filter submenu and the pill popover.
export const FILTER_SUBMENU_WIDTH = 'w-70';
